import { z } from "zod";

const CreateAuditRegistrySchema = z
  .object({
    name: z
      .string()
      .min(1, { message: "Name is required." })
      .max(400, { message: "Name must not be longer than 400 characters." }),
  })
  .strict();

export default CreateAuditRegistrySchema;
